import 'intersection-observer-polyfill/index.global'
import * as React from 'react'
import GlobalLayout from './src/containers/GlobalLayout'
import * as Sentry from '@sentry/gatsby'
import type { WrapPageElementNodeArgs } from 'gatsby'
import config from './src/config'

if (config.modules.sentry.active) {
  Sentry.init({
    dsn: config.modules.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['error'] })
    ],
    enableLogs: true,

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: config.modules.sentry.tracesSampleRate,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: config.modules.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: config.modules.sentry.replaysOnErrorSampleRate,

    // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/www\.lusini\.com(?:\/|$)/
      // TODO: replace with int: /^https:\/\/www\.lusini\.dev(?:\/|$)/
    ]

    // Debug mode for development
    // debug: process.env.NODE_ENV === 'development'
  })
}

export function wrapPageElement({ element, props }: WrapPageElementNodeArgs) {
  return <GlobalLayout {...props}>{element}</GlobalLayout>
}

export function disableCorePrefetching() {
  return true
}
